import { AddressDetailsData } from '../models'

export enum AddressError {
  StreetAddressMayNotBeEmpty,
  CityMayNotBeEmpty,
  CountryMayNotBeEmpty,
  RegionMayNotBeEmpty,
  PostalCodeMayNotBeEmpty,
}

export enum AddressErrorLanguage {
  Default,
}

export const AddressErrorMessages: Record<AddressErrorLanguage, Record<AddressError, string>> = {
  [AddressErrorLanguage.Default]: {
    [AddressError.StreetAddressMayNotBeEmpty]: 'Street address may not be empty',
    [AddressError.CityMayNotBeEmpty]: 'City may not be empty',
    [AddressError.CountryMayNotBeEmpty]: 'Country may not be empty',
    [AddressError.RegionMayNotBeEmpty]: 'State/Region may not be empty',
    [AddressError.PostalCodeMayNotBeEmpty]: 'Postal Code may not be empty',
  },
}

export class AddressDetailsWrapper {
  constructor(data?: AddressDetailsData, errorPrefix?: string, language = AddressErrorLanguage.Default) {
    this.data = data ?? {}
    this.errorPrefix = errorPrefix
    this.language = language
  }

  public data: AddressDetailsData
  private errorPrefix?: string
  private language: AddressErrorLanguage
  private get errorMessages() {
    return AddressErrorMessages[this.language]
  }

  public setAddress(value: string) {
    this.data.address = value
  }

  private createError(error: AddressError) {
    const message = this.errorMessages[error]
    return Error(this.errorPrefix ? `${this.errorPrefix}: ${message}` : message)
  }

  public validateAddress() {
    if ((this.data.address?.length ?? 0) <= 0) {
      return this.createError(AddressError.StreetAddressMayNotBeEmpty)
    }
  }

  public setAddress2(value: string) {
    this.data.address2 = value
  }

  public validateAddress2() {
    return
  }

  public setCity(value: string) {
    this.data.city = value
  }

  public validateCity() {
    if ((this.data.city?.length ?? 0) <= 0) {
      return this.createError(AddressError.CityMayNotBeEmpty)
    }
  }

  public setCountry(value: string) {
    this.data.country = value
  }

  public validateCountry() {
    if ((this.data.country?.length ?? 0) <= 0) {
      return this.createError(AddressError.CountryMayNotBeEmpty)
    }
  }

  public setRegion(value: string) {
    this.data.region = value
  }

  public validateRegion() {
    if ((this.data.region?.length ?? 0) <= 0) {
      return this.createError(AddressError.RegionMayNotBeEmpty)
    }
  }

  public setPostalCode(value: string) {
    this.data.postalCode = value
  }

  public validatePostalCode() {
    if ((this.data.postalCode?.length ?? 0) <= 0) {
      return this.createError(AddressError.PostalCodeMayNotBeEmpty)
    }
  }

  public valid() {
    return this.errors().length === 0
  }

  public errors() {
    return [this.validateAddress(), this.validateCity(), this.validateRegion(), this.validateCountry(), this.validatePostalCode()].filter(
      (error) => error !== undefined,
    ) as Error[]
  }
}
